import React from 'react';
import './Quit.css'; 
import '../App.css';

const Quit = ({ playerName, forceRemove, removePlayer, setConfirmQuit, resetEverything, setGame, role, socket, sessionId, inGameContext = false }) => {
  const handleQuit = () => {
    setConfirmQuit(false);

    if (role === 'host' && socket && sessionId) {
      console.log('Closing session:', sessionId, 'as host');
      
      let callbackFired = false;
      
      // Close the session on the server
      socket.emit('closeSession', { sessionId }, (response) => {
        callbackFired = true;
        console.log('Session close response:', response);
        
        // Give the server time to process and broadcast the close to all clients
        // before we disconnect
        setTimeout(() => {
          console.log('Callback fired - resetting after delay');
          resetEverything();
          setGame(null);
        }, 300);
      });
      
      // Fallback timeout - if server doesn't respond within 2 seconds, disconnect anyway
      setTimeout(() => {
        if (!callbackFired) {
          console.log('Session close callback timeout - forcing reset');
          resetEverything();
          setGame(null);
        }
      }, 2000);
      return;
    }

    // Player quit path
    if (removePlayer) {
      removePlayer(playerName, forceRemove);
    }
    resetEverything();
    setGame(null);

  };

  return (
    <div>
        <div className="overlay">
          <div className="overlay-content">
            <h1>{inGameContext ? 'Leave Game' : 'Quit Game'}</h1>
            <h4>Are you sure you want to {inGameContext ? 'leave' : 'quit'} the game?</h4>
            <button onClick={() => setConfirmQuit(false)}>Cancel</button>
            <button onClick={handleQuit}>{inGameContext ? 'Leave' : 'Quit'}</button>
          </div>
        </div>
    </div>
  );
};

export default Quit;
